import React from 'react';
import Input from '../../forms/Input';
import { QuestRoute } from '../../api/QuestRoutes';
import Checkbox from '../../forms/Checkbox';
import Select from '../../forms/Select';
import Table from '../../table/Table';
import { generateId } from '../../utility/functions';
import Button from '../../forms/Button';
import PageBreak from '../../layout/PageBreak';
import HamQuest from '../../api/HamQuestGiver';
import GetState from '../../GetState';
import Form from '../../forms/Form';
import { userRoles } from '../../RoleProtected';
import ManagementRow from '../../table/ManagementRow';
import ModalFactory from '../../Modal';

const WashBundles = ({ ...props }) => {

    const [bundles, refreshBundles] = GetState(QuestRoute.codes.washBundle)

    const BundleForm = ({ values, editing }) => (
        <>
            <Select
                label='Wash Bundle'
                name={editing ? '' : 'codeBundleItemId'}
                getOptions={QuestRoute.kiosks.codeBundle}
                buildOptions={e => {
                    e.label = e.name;
                    e.value = e.id;
                    e.disabled = bundles.find(f => f.codeBundleItemId === e.id);
                }}
                disabled={editing}
                required
            />
            <Select
                label='Vend Item'
                name='kioskItemId'
                getOptions={QuestRoute.kiosks.wash}
                buildOptions={e => {
                    e.label = e.name;
                    e.value = e.id;
                }}
                required
            />
            <Input
                label='Max Uses'
                name='maxUses'
                type='number'
                min={1}
                required
            />
            <Checkbox
                label='Has Expiration'
                name='hasExpiration'
            />
            {values.hasExpiration &&
                <>
                    <Input
                        label='Expiration Years'
                        name='expYears'
                        type='number'
                        min={0}
                    // disable={!values.hasExpiration}
                    />
                    <Input
                        label='Expiration Months'
                        name='expMonths'
                        type='number'
                        min={0}
                    // disable={!values.hasExpiration}
                    />
                    <Input
                        label='Expiration Days'
                        name='expDays'
                        type='number'
                        min={0}
                    // disable={!values.hasExpiration}
                    />
                </>
            }
        </>
    )

    const deleteBundle = (code) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${code.bundleName}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Wash Club',
                body: `Deleting ${code.bundleName}`,
                callback: () => HamQuest.delete(QuestRoute.codes.editWashBundle(code.codeBundleItemId))
            },
            confirmed: {
                title: 'Success',
                body: `${code.bundleName} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshBundles()
        })
    }

    const editBundle = (bundle) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${bundle.bundleName}`,
            body: (
                <Form
                    name='washBundleSettings'
                    inputs={{ ...bundle }}
                    onSubmit={e => {
                        return HamQuest.put(QuestRoute.codes.editWashBundle(e.codeBundleItemId), { ...e })
                            .then(() => {
                                refreshBundles();
                                ModalFactory.close(id);
                            })
                    }}
                    text='Update'
                >
                    {({ values }) => <BundleForm values={values} editing />}
                </Form>
            )
        })
    }

    const addNewBundle = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add a new Bundle`,
            body: (
                <Form
                    name='washBundleSettings'
                    inputs={{
                        SKU: '',
                        name: '',
                        price: ''
                    }}
                    onSubmit={e => HamQuest.post(QuestRoute.codes.washBundleItems, { ...e })
                        .then(() => {
                            addWashBundle();
                            ModalFactory.close(id);
                        })
                    }
                    text='Add'
                >
                    {({ values }) =>
                        <>
                            <Input
                                label='SKU'
                                name='SKU'
                                required
                            />
                            <Input
                                label='Name'
                                name='name'
                                required
                            />
                            <Input
                                label='Price'
                                name='price'
                                type='price'
                                min={0.01}
                                step={0.01}
                                required
                            />
                        </>
                    }
                </Form>
            )
        })
    }

    const addWashBundle = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add a new Award`,
            body: (
                <Form
                    inputs={{
                        'bundleName': '',
                        'kioskName': '',
                        'codeBundleItemId': '',
                        'kioskItemId': '',
                        'maxUses': '',
                        'hasExpiration': false,
                        'expYears': '',
                        'expMonths': '',
                        'expDays': '',
                        'expiration': ''
                    }}
                    onSubmit={e => HamQuest.post(QuestRoute.codes.washBundle, { ...e })
                        .then(() => {
                            refreshBundles();
                            ModalFactory.close(id);
                        })
                    }
                    text='Add'
                >
                    {({ values }) => <BundleForm values={values} />}
                </Form>
            )
        })
    }

    return (
        <PageBreak>
            <Table
                config={{
                    // label: 'Wash Bundles',
                    controls: [
                        <Button roles={userRoles.editProducts} onClick={addWashBundle}>New Wash Bundle</Button>,
                        <Button roles={userRoles.editProducts} onClick={addNewBundle}>Add Bundle</Button>,
                    ],
                    data: bundles,
                    // disableHeaderSearch: true,
                    headers: [
                        {
                            label: 'Bundle Name',
                            propKey: 'bundleName',
                        }, {
                            label: 'Bundle SKU',
                            propKey: 'bundleSKU',
                        }, {
                            label: 'Kiosk Item',
                            propKey: 'kioskName',
                            options: true,
                        }, {
                            label: 'Kiosk SKU',
                            propKey: 'kioskSKU',
                        }, {
                            label: 'Max Uses',
                            propKey: 'maxUses',
                        }, {
                            label: 'Expiration',
                            propKey: 'expiration',
                        },
                    ],
                    renderFormat: (e) => (
                        <ManagementRow
                            key={generateId()}
                            controls={[
                                <Button roles={userRoles.editProducts} key={generateId()} onClick={() => editBundle(e)}>Edit</Button>,
                                <Button roles={userRoles.editProducts} key={generateId()} onClick={() => deleteBundle(e)}>Delete</Button>
                            ]}
                        >
                            <td>{e.bundleName}</td>
                            <td>{e.bundleSKU}</td>
                            <td>{e.kioskName}</td>
                            <td>{e.kioskSKU}</td>
                            <td>{e.maxUses}</td>
                            <td>{e.expiration.match(/0/g)?.length === 3 ? '-' : e.expiration}</td>
                        </ManagementRow>
                    )
                }}
            />
        </PageBreak>
    );
}

export default WashBundles;